import {useEffect, useRef} from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import './Chart.scss';

am4core.addLicense('CH332271218');

am4core.useTheme(am4themes_animated);

const CompareChart = ({chartData, title, chartId, indicators}: any) => {
  const chartRef: any = useRef(null);
  useEffect(() => {

    chartRef.current = am4core.create(chartId, am4charts.XYChart);
    const chartTitle = chartRef.current.titles.create();
    chartTitle.text = title
    chartTitle.fontSize = 25;
    chartTitle.marginBottom = 10;

    chartRef.current.data = chartData;
    chartRef.current.dateFormatter.inputDateFormat = 'yyyy-MM-dd';

    const dateAxis = chartRef.current.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.strokeWidth = 1;
    dateAxis.renderer.grid.template.strokeOpacity = 0.3;
    dateAxis.renderer.grid.template.stroke = '#fff';
    dateAxis.renderer.minGridDistance = 40;
    dateAxis.renderer.labels.template.fontSize = 10;
    dateAxis.title.fontWeight = 'bold';
    dateAxis.dateFormats.setKey('month', 'MMM YY');
    dateAxis.renderer.labels.template.fill = '#fff';

    const valueAxis = chartRef.current.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.grid.template.stroke = '#fff';
    valueAxis.renderer.grid.template.strokeWidth = 1;
    valueAxis.renderer.grid.template.strokeOpacity = 0.3;
    valueAxis.title.fontWeight = 'bold';
    valueAxis.renderer.labels.template.fontSize = 10;
    valueAxis.renderer.labels.template.fill = '#fff';

    const createSeries = (field: any, name: any, color: string) => {
      const series = chartRef.current.series.push(new am4charts.LineSeries());
      series.dummyData = {
        field: field
      };
      series.dataFields.valueY = field;
      series.dataFields.dateX = 'date';
      series.name = name;
      series.tooltipText = "[font-size: 14]{name}[/]{categoryX}: [font-size: 14]{" + field + "}[/]";
      series.strokeWidth = 1;
      series.fillOpacity = 1;
      series.tensionX = 0.8;
      series.stroke = color;
      series.fill = color;
      return series;
    };

    createSeries('change_monthly', indicators[0], '#f7b047')
    createSeries('change_lag', indicators[1], '#A010C7')


    chartRef.current.legend = new am4charts.Legend();
    chartRef.current.legend.itemContainers.template.togglable = false;
    chartRef.current.legend.itemContainers.template.cursorOverStyle = am4core.MouseCursorStyle.default;
    chartRef.current.legend.position = "bottom"
    chartRef.current.legend.reverseOrder = true;

    chartRef.current.cursor = new am4charts.XYCursor();
    chartRef.current.cursor.maxTooltipDistance = 0;


    // Responsive
    chartRef.current.responsive.enabled = true;
    chartRef.current.responsive.useDefault = false;
    chartRef.current.responsive.rules.push({
      relevant: am4core.ResponsiveBreakpoints.widthL,
      state: (target: any, stateId: any) => {
        if (target instanceof am4charts.Legend) {
          const state = target.states.create(stateId);
          state.properties.position = "bottom";
          return state;
        }
        return null;
      }
    });

    // Prepare data for the river-stacked series
    chartRef.current.events.on("beforedatavalidated", () => {
      const data = chartRef.current.data;
      if (data.length === 0) {
        return;
      }
      for (let i = 0; i < data.length; i++) {
        const row = data[i];
        let sum = 0;

        // Calculate open and close values
        chartRef.current.series.each((series: any) => {
          const field = series.dummyData.field;
          const val = Number(row[field]);
          row[field + "_low"] = sum;
          row[field + "_hi"] = sum + val;
          sum += val;
        });

        // Adjust values so they are centered
        const offset = sum / 2;
        chartRef.current.series.each((series: any) => {
          const field = series.dummyData.field;
          row[field + "_low"] -= offset;
          row[field + "_hi"] -= offset;
        });
      }
    });


    // chartRef.current.cursor = new am4charts.XYCursor();
    // chartRef.current.cursor.xAxis = dateAxis;

    return () => {
      chartRef.current && chartRef.current.dispose();
    };
  }, [chartData, chartId]);

  return (
    <div className='what-if-chart'>
      <div className='chart-area' id={chartId} ref={chartRef}/>
    </div>
  );
};

export default CompareChart;
